import _ from 'lodash';
import { storeKeys } from "services/store/keys";
import HelperString from 'utils/helper-string'

export default class SecureStoreServiceBase {
	static sessionPrefix = null;
	
	static async createNewPrefix(){
		let prefix = HelperString.random( 4 );
		
		await this.get( storeKeys.SESSION_PREFIXES ).then( result => {
			if ( result !== null ) {
				while( result.includes( prefix ) ){
					prefix = HelperString.random( 4 );
				}
			}
		});
		
		return prefix;
	}
	
	static setSessionPrefix( sessionPrefix ){
		this.sessionPrefix = sessionPrefix;
	}
	
	static async setMulti( list ) {
		return Promise.all(
			_.map( list, async( value, key ) => {
				await this.set( key, value );
			})
		);
	}
	
	static async getMulti( list ) {
		let return_data = {};
		
		await Promise.all(
			_.map( list, async ( value ) => {
				await this.get( value ).then( ( result ) => {
					return_data[ value ] = result;
				});
			})
		);
		
		return return_data;
	}
	
	static async deleteMulti( list ) {
		return Promise.all(
			_.map( list, async value => {
				const result = await this.get( value );

				if( result !== null ){
					return this.delete( value );
				}

				return null;
			})
		);
	}
	
	static async deleteAll() {
		const keys = _.map( storeKeys, key => {
			return key;
		} );
		
		return await Promise.all(
			_.map( keys, async key => {
				await this.delete( key );
			})
		);
	}
}
